import * as React from 'react';
export const bangorsavingsSvg = React.forwardRef(function bangorsavingsSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#00539A',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M8 6v20h10.465c6.36 0 7.313-3.407 7.313-5.43 0-2.41-1.563-4.2-4.17-4.884 1.332-.462 3.68-1.653 3.68-4.377 0-3.268-2.885-5.3-7.526-5.3L8 6Zm8.672 12.013c1.849 0 2.597.59 2.597 2.05 0 1.459-1.34 2.05-2.597 2.05H13.63v-4.1h3.042Zm-.315-8.135c.638 0 2.727.139 2.727 1.976 0 1.625-1.488 1.976-2.727 1.976H13.63V9.887l2.727-.009Z',
      fill: '#fff',
    }),
  );
});
bangorsavingsSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var bangorsavings = {
  category: 'brand',
  colorable: false,
  name: 'bangorsavings',
  svg: bangorsavingsSvg,
};
